// Node-coloring React context provider. The context + `useNodeColoring`
// hook live in `useNodeColoring.ts` (component-free); this file holds only
// the provider component.

import { type ReactNode } from "react";
import type { NodeColoring } from "./types.js";
import { NodeColoringContext } from "./useNodeColoring.js";

export function NodeColoringProvider({
  value,
  children,
}: {
  value: NodeColoring | null;
  children: ReactNode;
}) {
  return (
    <NodeColoringContext.Provider value={value}>{children}</NodeColoringContext.Provider>
  );
}
